import { render, staticRenderFns } from "./WorkspaceTokens.vue?vue&type=template&id=7ff938a2"
import script from "./WorkspaceTokens.vue?vue&type=script&lang=js"
export * from "./WorkspaceTokens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports